<script lang="ts">
  import { theme } from '@shared/ui/theme';
  import { cn } from '@shared/utils';

  export let classes = '';

  export let blur: 'sm' | 'md' = 'sm';

  const blurClasses = {
    sm: 'bg-default-50/20 dark:bg-dark-50/10 dark:backdrop-blur-3xl',
    md: 'bg-default-50/10 dark:bg-dark-50/5',
  };
</script>

<div
  class="{cn(
    'absolute bottom-0 left-0 right-0 top-0 h-full w-full translate-y-[10%] scale-[90%] overflow-hidden rounded-xl',
    classes,
  )}"
>
  <slot />

  <div
    class="{cn(
      'absolute inset-0 rounded-xl backdrop-blur-lg before:absolute before:bottom-0 before:left-0 before:right-0 before:top-1/2 before:z-[2] before:rounded-xl before:backdrop-blur-[0px]',
      blurClasses[blur],
      {
        'custom-gradient-dark': $theme === 'dark',
      },
    )}"
  ></div>
</div>

<style lang="scss">
  .custom-gradient-dark::before {
    background: linear-gradient(180deg, rgba(64, 64, 64, 0) 0%, rgba(64, 64, 64, 0.7) 100%);
  }
</style>
